import { render, staticRenderFns } from "./qReleaseSetting.vue?vue&type=template&id=d59ffeb6&"
import script from "./qReleaseSetting.vue?vue&type=script&lang=ts&"
export * from "./qReleaseSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports